<template>
  <LegalDocShell
    title="隐私政策"
    crumb-label="隐私政策"
    :nav-items="navItems"
  >
    <template #intro>
      笔芯科研（以下简称「我们」）通过网站 bixinpaper.com 及关联在线服务向您提供文本处理与 AI 辅助工具。
      我们重视您的个人信息保护，本政策说明我们如何收集、使用、存储与保护相关信息。
      <strong>与您的权益密切相关的条款，我们已以加粗方式提示。</strong>
    </template>

    <section
      v-for="(section, index) in sections"
      :id="'privacy-section-' + index"
      :key="section.title"
      class="legal-block"
    >
      <h2>{{ section.title }}</h2>
      <p v-for="(para, idx) in section.paragraphs" :key="'p-' + idx">{{ para }}</p>
      <ul v-if="section.list && section.list.length">
        <li v-for="(item, idx) in section.list" :key="'l-' + idx">{{ item }}</li>
      </ul>
    </section>
  </LegalDocShell>
</template>

<script>
import LegalDocShell from '@/components/legal/LegalDocShell.vue'

export default {
  name: 'PrivacyView',
  components: { LegalDocShell },
  computed: {
    navItems() {
      return this.sections.map((section, index) => ({
        id: 'privacy-section-' + index,
        label: section.title
      }))
    }
  },
  data() {
    return {
      sections: [
        {
          title: '一、我们收集的信息',
          paragraphs: [
            '为向您提供登录、计费、处理记录与客服支持，我们可能收集以下信息：'
          ],
          list: [
            '微信登录信息：包括 OpenID、UnionID（如有）、微信昵称与头像（以微信授权范围为准）',
            '账户信息：平台用户名、注册时间、邀请关系、生日（如您主动填写）',
            '交易与点数信息：充值订单、点数变动记录、功能使用消耗',
            '内容与任务信息：您上传或粘贴的文本、处理参数、任务状态与结果（用于完成您请求的服务）',
            '设备与日志信息：浏览器类型、访问时间、IP 地址、操作日志（用于安全与故障排查）',
            'Cookie 及本地存储：用于维持登录状态、记住偏好设置及统计匿名访问情况'
          ]
        },
        {
          title: '二、信息的使用目的',
          paragraphs: [
            '我们仅在合法、正当、必要的范围内使用您的信息，主要包括：'
          ],
          list: [
            '提供、维护与改进平台功能',
            '完成登录鉴权、点数计费与订单处理',
            '展示处理历史、邀请奖励与账户资料',
            '防范欺诈、滥用与安全风险',
            '遵守法律法规或响应有权机关要求',
            '在获得您同意的情况下发送服务通知或活动信息'
          ]
        },
        {
          title: '三、信息的共享与披露',
          paragraphs: [
            '我们不会出售您的个人信息。仅在以下情形可能共享或披露：',
            '（1）经您明确同意；',
            '（2）为完成支付、云存储、AI 推理等必要服务，向合作服务商提供最小必要信息（均签署保密与安全要求）；',
            '（3）依据法律法规、诉讼、仲裁或政府主管部门要求；',
            '（4）在合并、收购或重组时，依法转移相关信息并继续受本政策约束。'
          ]
        },
        {
          title: '四、信息的存储与保护',
          paragraphs: [
            '我们在中华人民共和国境内存储数据，并采取访问控制、传输加密、日志审计等安全措施保护您的信息。',
            '我们仅在实际需要期间保留您的信息。账户注销或法定保存期限届满后，我们将删除或匿名化处理相关数据，法律法规另有规定的除外。',
            '尽管我们已采取合理措施，互联网传输仍可能存在风险，请您妥善保管账号与设备安全。'
          ]
        },
        {
          title: '五、您的权利',
          paragraphs: [
            '在法律法规允许范围内，您可以：'
          ],
          list: [
            '查询、更正您的个人资料（如生日等可在个人资料中修改）',
            '查阅点数流水与处理记录',
            '撤回部分授权（可能导致相关功能不可用）',
            '申请注销账号——请通过页脚公示的邮箱联系我们，我们将在核实身份后处理',
            '获取我们持有的您的个人信息副本（法律法规允许的范围内）'
          ]
        },
        {
          title: '六、Cookie 与同类技术',
          paragraphs: [
            '我们使用 Cookie 和浏览器本地存储以维持登录 Token、缓存偏好及统计访问量。您可通过浏览器设置管理或清除 Cookie，但可能影响登录与部分功能使用。'
          ]
        },
        {
          title: '七、未成年人保护',
          paragraphs: [
            '本平台主要面向成年人用户。若您未满十四周岁，请在监护人同意并指导下使用本平台。若监护人发现未成年人未经同意提供了个人信息，请通过页脚联系方式联系我们删除。'
          ]
        },
        {
          title: '八、政策更新',
          paragraphs: [
            '我们可能适时修订本政策。重大变更将在网站显著位置提示。若您继续使用服务，即表示接受更新后的政策；若不同意，请停止使用并通过页脚联系方式申请注销账号。'
          ]
        }
      ]
    }
  }
}
</script>
